import { Pipe, PipeTransform } from '@angular/core';
import { DropdownItem } from '@shared/ui/dropdown/interfaces/dropdown-item';
import { isDropdownNestedItem } from '@shared/ui/dropdown/helpers/dropdown-type-guards';

@Pipe({
  name: 'isDropdownNestedItem',
  standalone: false
})
export class IsDropdownNestedItemPipe implements PipeTransform {
  transform(item: DropdownItem): boolean {
    return isDropdownNestedItem(item);
  }
}
